export default {

  init() {
    let Video = this;
    
    // For videos with placeholder images
    $('[data-video-target]').on('click', function(e) {
      e.preventDefault();

      let trigger = this.getAttribute('data-video-target');
      let target = document.getElementById(trigger);
      let videoProvider = this.getAttribute('data-video-provider');
      let videoUrl = this.getAttribute('data-video-url');
      let template = Video.getTemplate(Video.getVideoId(videoUrl, videoProvider), videoProvider);

      $(this).parents('.video__body').remove();
      $(target).addClass('embed-responsive').html(template);
      Video.trackVideo();
    });

    // For videos without placeholder images
    $('[data-video-load]').each(function(){

      let videoProvider = this.getAttribute('data-video-provider');
      let videoUrl = this.getAttribute('data-video-url');
      let template = Video.getTemplate(Video.getVideoId(videoUrl, videoProvider), videoProvider);
      
      $(this).replaceWith($(template));
      Video.trackVideo();
    });

  },

  getTemplate(videoId, platform) {
    let template = '';

    if(platform.toLowerCase() == 'youtube') {
      template = `<iframe src="//www.youtube.com/embed/${videoId}?controls=1&autoplay=1&amp;modestbranding=1&amp;rel=0" width="100%" height="148" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }

    if(platform.toLowerCase() == 'vimeo') {
      template = `<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }

    return template;
  },

  getVideoId(url, platform) {
    if(platform.toLowerCase() == 'youtube') {
      const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      return url.match(pattern)[2];
    }

    if(platform.toLowerCase() == 'vimeo') {
      const pattern = /vimeo.*\/(\d+)/i;
      return url.match(pattern)[1];
    }

    return;
  },

  trackVideo() {
    console.log('trackVideo()');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'initiateVideo'});
  }

};
